import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder, userManagement } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const roleApi = createApi({
  reducerPath: 'roleApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_USER_MANAGEMENT_BASE_URL }),
  tagTypes: ['role'],
  endpoints: (builder) => ({
    getRoles: builder.mutation({
      query(body) {
        return {
          url: userManagement.roleController.getRoles+"?merchantId="+body.merchantId,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    addRole: builder.mutation({
      query(body) {
        return {
          url: userManagement.roleController.addRole,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    findRoleById: builder.mutation({
      query(body) {
        return {
          url: userManagement.roleController.findRoleById,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateRole: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.roleController.updateRole}`,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteRole: builder.mutation({
      query(body) {
        return {
          url: userManagement.roleController.deleteRole,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetRolesMutation,
  useAddRoleMutation,
  useDeleteRoleMutation,
  useFindRoleByIdMutation,
  useUpdateRoleMutation,
} = roleApi;
